export default __webpack_public_path__ + "static/media/stats3.51b588b2.png";